import { useTranslation } from "react-i18next";
import { IconCarrot } from "../../../../common/icons/IconCarrot/IconCarrot";
import { AboTileData } from "../../../../services/BronzeGroupTracking/bronzeGroupTracking.types";
import defaultContent from "../../../../content/bronzeGroupTracking";
import "./TrackingTile.scss";
import { BRONZE_TAGS } from "../../../../reducers/model/bgtFilters";
import { BGTTags, getReqTitle, IncentiveTag } from "../../bronzeGroupTrackingUtils";
import { getDisplayName } from "../../../../common/util/displayName";
import { BGTRequirementIcons } from "../../BGTRequirementDonuts/BGTRequirementIcons";
import { BUSINESS_NATURE } from "../../../../common/enums/businessNatures";

type Props = AboTileData & {
  viewState?: "desktop" | "mobile";
  isMemberPlusMarket?: boolean;
};

export const TrackingTile = ({
  eligibilityTag,
  aboName,
  aboLocalName,
  displayName,
  isoLanguage,
  aboNumber,
  affNumber,
  reqTrackingTag,
  closeNewTag,
  incentiveTag,
  requirements,
  graduated,
  graduationPeriod,
  restarted,
  businessNature,
  viewState = "desktop",
  isMemberPlusMarket = false,
}: Props) => {
  const { t } = useTranslation(["bronzeGroupTracking"]);

  // Use backend-resolved displayName with translation
  const aboDisplayName = getDisplayName(displayName, t);

  requirements = requirements.map((req) => {
    return { ...req, text: getReqTitle(req).toString() };
  });

  const BGTLeafTags = () => {
    const tags = [closeNewTag, reqTrackingTag];
    if (restarted) tags.push(BRONZE_TAGS.RESTARTED);
    if (businessNature === BUSINESS_NATURE.MEMBER_PLUS && isMemberPlusMarket) tags.push(BRONZE_TAGS.MEMBER_PLUS);

    return <>{tags.map((tag) => BGTTags(tag))}</>;
  };

  const EligibilityTag = () => <p>{`${t(`${eligibilityTag}`, defaultContent[eligibilityTag])}`}</p>;

  const AboTrackingTileMobile = () => {
    return (
      <div className="aboTrackingTile aboTrackingTile__display--mobile">
        <div className="aboTrackingTile__group">
          <div className="aboTrackingTile__incentiveTags aboTrackingTile__incentiveTags--mobile">
            <IncentiveTag incentiveTag={incentiveTag} />
            <div className="aboTrackingTile__eligiblityTag--mobile">
              <EligibilityTag />
            </div>
          </div>
          <div className="aboTrackingTile__aboName">{aboDisplayName}</div>
          <p className="aboTrackingTile__aboNum">#{aboNumber}</p>
          <div className="aboTrackingTile__requirements--mobile">
            <BGTRequirementIcons requirements={requirements} layout="vertical" />
          </div>
          <div className="aboTrackingTile__infoTags aboTrackingTile__cell aboTrackingTile__cell--tags">
            <BGTLeafTags />
          </div>
        </div>
        <div className="aboTrackingTile__arrow">
          <IconCarrot orientation="right" color="black" />
        </div>
      </div>
    );
  };

  const AboTrackingTileDesktop = () => {
    return (
      <div className="aboTrackingTile aboTrackingTile__display--desktop">
        <div className="aboTrackingTile__aboNameNum aboTrackingTile__cell aboTrackingTile__cell--name">
          <span className="aboTrackingTile__aboName">{aboDisplayName}</span>
          <span className="aboTrackingTile__aboNum">#{aboNumber}</span>
        </div>
        <div className="aboTrackingTile__incentiveTags aboTrackingTile__cell">
          <IncentiveTag incentiveTag={incentiveTag} />
        </div>

        <div className="aboTrackingTile__infoTags aboTrackingTile__cell aboTrackingTile__cell--tags">
          <BGTLeafTags />
        </div>

        <div className="aboTrackingTile__cell aboTrackingTile__cell--progress">
          <BGTRequirementIcons requirements={requirements} layout="vertical" enableToolTips />
        </div>

        <div className="aboTrackingTile__cell aboTrackingTile__cell--eligibility">
          <EligibilityTag />
        </div>

        <div className="aboTrackingTile__arrow">
          <IconCarrot orientation="right" color="black" />
        </div>
      </div>
    );
  };

  return <>{viewState === "mobile" ? <AboTrackingTileMobile /> : <AboTrackingTileDesktop />}</>;
};
